import React from "react";
import Bugsnag, {Plugin} from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// Remember that only "staging" and "production" release stages will report errors
export const initClientBugsnag = (
    apiKey: string,
    releaseStage: "staging" | "stage:top" | "stage:dev" | "stage:ovh" | "production" | "development",
    enabledReleaseStages = ["production", "stage:top", "stage:dev", "stage:ovh", "staging"]
) => {
    if (Bugsnag.isStarted()) {
        return;
    }

    Bugsnag.start({
        apiKey,
        releaseStage,
        enabledReleaseStages,
        plugins: [new BugsnagPluginReact() as Plugin],
        logger: null,
        redactedKeys: [/^password$/i]
    });
};

export const getBugsnagErrorBoundary = () => {
    // BANG: if bugsnag for some reason does not work properly we need to throw an Error
    return Bugsnag.getPlugin("react")!.createErrorBoundary(React);
};
import React from "react";
import Bugsnag, {Plugin} from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// Remember that only "staging" and "production" release stages will report errors
export const initClientBugsnag = (
    apiKey: string,
    releaseStage: "staging" | "stage:top" | "stage:dev" | "stage:ovh" | "production" | "development",
    enabledReleaseStages = ["production", "stage:top", "stage:dev", "stage:ovh", "staging"]
) => {
    if (Bugsnag.isStarted()) {
        return;
    }

    Bugsnag.start({
        apiKey,
        releaseStage,
        enabledReleaseStages,
        plugins: [new BugsnagPluginReact() as Plugin],
        logger: null,
        redactedKeys: [/^password$/i]
    });
};

export const getBugsnagErrorBoundary = () => {
    // BANG: if bugsnag for some reason does not work properly we need to throw an Error
    return Bugsnag.getPlugin("react")!.createErrorBoundary(React);
};
